/**
 * Single import point for all per-order mock data.
 *
 * Components call `getOrderMocks(orderId)` to pull conversations,
 * activity log, production photos, signatures, invoices, and CoPilot
 * thread state. Keeping these out of fixtures.js avoids bloating the
 * canonical step list.
 */
import { CONVERSATIONS, channelLabel, getConversation } from './conversations';
import { ACTIVITY, TYPE_LABEL } from './activity';
import { PRODUCTION_UPDATES } from './production';
import { SIGNATURES } from './signatures';
import { INVOICES } from './invoices';
import {
  SUGGESTED_PROMPTS,
  INITIAL_THREADS,
  RESPONSES,
  FALLBACK_REPLY,
  ACTION_EFFECTS,
} from './copilot';

export const getOrderMocks = (orderId) => ({
  conversations: CONVERSATIONS[orderId] || {},
  activity:      ACTIVITY[orderId] || [],
  production:    PRODUCTION_UPDATES[orderId] || [],
  signatures:    SIGNATURES[orderId] || [],
  invoice:       INVOICES[orderId] || null,
  coPilot: {
    suggested: SUGGESTED_PROMPTS[orderId] || [],
    initial:   INITIAL_THREADS[orderId] || [],
  },
});

export {
  channelLabel, getConversation,
  TYPE_LABEL,
  RESPONSES, FALLBACK_REPLY, ACTION_EFFECTS,
};
